export default __webpack_public_path__ + "static/media/ghost.7cbbe743.svg";